module.exports = __webpack_public_path__ + "img/bigImage2.6e87cc5f.jpg";